import React from 'react'
// import './Checkout.css';
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js'
import { useState } from 'react'

const Checkout = ({payload,callAfterPayment}:any) => {
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer()
  const [currency, setCurrency] = useState(options.currency)

  const onCurrencyChange = ({ target: { value } }: any) => {
    setCurrency(value)
    dispatch({
      type: 'resetOptions',
      value: {
        ...options,
        currency: value,
      },
    })
  }

  const onCreateOrder = (data: any, actions: any) => {
          console.log({data})
          console.log({actions})

    return payload?.providerOrderId
  }

  const onApproveOrder = (data: any, actions: any) => {
          console.log({data})

    return actions.order.capture().then((details: any) => {
          const data={
                    status:details?.status==="COMPLETED"?true:false,
                    id:details?.id
          }
          callAfterPayment(data)
          console.log({details})
//       const name = details.payer.name.given_name
//       
//       alert(`Transaction completed by ${name}`)
    })
  }
  
  const onCancelOrder = (data: any) => {
          console.log({data})
          
          const resData={
                    status:false,
                    id:data?.orderID
          }

          callAfterPayment(resData)
   
  }

  return (
    <div className='checkout'>
      {isPending ? (
        <p>LOADING...</p>
      ) : (
        <>
          <select value={currency} onChange={onCurrencyChange}>
            <option value='USD'>💵 USD</option>
            <option value='EUR'>💶 Euro</option>
          </select>
          <PayPalButtons
            style={{ layout: 'vertical' }}
            createOrder={(data, actions) => onCreateOrder(data, actions)}
            onApprove={(data, actions) => onApproveOrder(data, actions)}
            onCancel={(data:any) => {
                    onCancelOrder(data)
                    console.log("Transaction cancelled", data);
                    // Handle canceled transaction (e.g., show a message to the user)
                  }}
                  onError={(err:any) => {
                    onCancelOrder(err)

                    console.error("Transaction failed", err);
                    // Handle error scenario (e.g., log error, notify user)
                  }}
          />
        </>
      )}
    </div>
  )
}

export default Checkout
